<bw-action-article-legacy maxWidth="516px">
  <ui-nav-exit-back header-actions [trackingDetail]="{ event_name: 'lender_alternatives' }"></ui-nav-exit-back>

  <div pre-title>
    <typography-legacy title-medium>{{ 'LENDER_ALTERNATIVE_TITLE' | translate }}</typography-legacy>
  </div>
  <div header-title>
    <typography-legacy class="mt-sm mb-sm">{{ 'LENDER_ALTERNATIVE_DESC' | translate }}</typography-legacy>
  </div>
  <div content-section>
    <div *ngIf="externalPartners$ | async as partners; else loading">
      <bw-action-details-card-legacy
        *ngFor="let partnerConfig of partners"
        [cardConfig]="partnerConfig"
        (ctaClicked)="onCtaClicked(partnerConfig.data)"
      ></bw-action-details-card-legacy>
    </div>
  </div>
  <div footer-top>
    <typography-legacy text-xsmall-semibold color="var(--secondary-text)" class="mt-sm">{{
      'LENDER_ALTERNATIVE_DISCLAIMER_TITLE' | translate
    }}</typography-legacy>
    <typography-legacy text-xsmall-regular class="disclaimer">
      {{ 'LENDER_ALTERNATIVE_DISCLAIMER_DESC' | translate }}
    </typography-legacy>
  </div>
</bw-action-article-legacy>
<ng-template #loading>
  <bw-spinner-legacy class="mb-md"></bw-spinner-legacy>
</ng-template>
